import styled from 'styled-components';

export const Card = styled.a.attrs({
  className: 'Card',
})`
  all: unset;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-radius: 5px;
  background-color: gray;
  width: 300px;
  // height: 210px;
  cursor: pointer;
  align-items: space-between;
  gap: 20px;
  padding-bottom: 10px;

  &:hover {
    opacity: 0.9;
  }
`;

export const ErrorMessage = styled.div.attrs({
  className: 'ErrorMessage',
})`
  color: #ccc;
  font-size: 14px;

  > button {
    margin-left: 8px;
    background: #444;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 4px 12px;
    cursor: pointer;
  }
`;

export const CardsContainer = styled.div.attrs({
  className: 'CardsContainer',
})<{ isActive: boolean }>`
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  gap: 20px;
  padding: 20px 0;
  width: 100%;
`;

export const ContentContainer = styled.div.attrs({
  className: 'ContentContainer',
})`
  // height: calc(100% - 60px);
  // gap: 15px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  color: white;
  width: 100%;
  align-items: center;
  // justify-content: center;
  height: 100%;
  font-size: 2em;
  margin-top: 58px;
`;

export const HomeContainer = styled.div.attrs({
  className: 'HomeContainer',
})`
  height: 100%;
`;

export const RowContainer = styled.div.attrs({
  className: 'RowContainer',
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #161616;
  padding: 10px;

  // Scroll-bar dark mode styling
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #444 #161616;
  /* WebKit (Chrome, Edge, Safari) */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #161616;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 6px;
    border: 2px solid #161616;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #666;
  }
`;

export const Tab = styled.div.attrs({
  className: 'Tab',
})<{ isActive: boolean }>`
  padding: 10px 20px;
  border-radius: 5px 5px 0 0;
  background-color: ${({ isActive }) => (isActive ? '#161616' : '#000')};
  cursor: pointer;
  &:hover {
    background-color: #161616;
  }
`;

export const TabContainer = styled.div.attrs({
  className: 'TabContainer',
})`
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`;
